import React, { useState } from 'react';
import {
  ModalOverlay,
  ModalContainer,
  ModalTitle,
  ModalDescription,
  ModalContent,
  LeftSection,
  RightSection,
  SchoolTag,
  CustomPlanTitle,
  CustomPlanDescription,
  RequestQuoteButton,
  AllInclusiveBanner,
  FeaturesGrid,
  FeatureItem,
  CheckIcon,
  CloseButton
} from './style';
import darkCheckCircle from '../../../static/icons/dark-check-circle.svg';
import { requestSchoolPlan } from '../../../service';


const SchoolPlanModal = ({ isOpen, onClose }) => {
  const [isRequesting, setIsRequesting] = useState(false);

  if (!isOpen) return null;

  const leftColumnFeatures = [
    "Full class access",
    "Unlimited drafts submissions", 
    "AI-assisted feedback",
    "Control student AI usage",
    "Curriculum-aligned rubrics",
    "Comment banks",
    "Teacher customisations",
    "Task creation"
  ];

  const rightColumnFeatures = [
    "Handwritten uploads",
    "Self-assessment",
    "Peer review", 
    "Exemplars",
    "Class insights",
    "LMS integrations",
    "Onboarding and training",
    "24/7 Support"
  ];

  const handleRequestQuote = async () => {
    setIsRequesting(true);
    try {
      window.open('https://calendly.com/d/zhj-c6q-pkq/jeddle-demonstration', '_blank');
      requestSchoolPlan();
      onClose();
    } finally {
      setIsRequesting(false);
    }
  };

  return (
    <ModalOverlay onClick={onClose}>
      <ModalContainer onClick={(e) => e.stopPropagation()}>
        <CloseButton onClick={onClose}>×</CloseButton>
        
        <ModalTitle>This feature is only available in the school plan</ModalTitle>
        <ModalDescription>
          The best way to learn and improve your skills. Get feedback on your work from JeddAI or go pro with your real-life experts.
        </ModalDescription>
        <AllInclusiveBanner>ALL INCLUSIVE</AllInclusiveBanner>
        <ModalContent>
          <LeftSection>
            <SchoolTag>SCHOOL</SchoolTag>
            <CustomPlanTitle>Custom plan</CustomPlanTitle>
            <CustomPlanDescription>Add your classes, give feedback effortlessly</CustomPlanDescription>
            <RequestQuoteButton onClick={handleRequestQuote} disabled={isRequesting}>
              Request a quote
            </RequestQuoteButton>
          </LeftSection>

          <RightSection>
          
            <FeaturesGrid>
              <div>
                {leftColumnFeatures.map((feature, index) => (
                  <FeatureItem key={index}>
                    <CheckIcon><img src={darkCheckCircle} /></CheckIcon>
                    <span>{feature}</span>
                  </FeatureItem>
                ))}
              </div>
              <div>
                {rightColumnFeatures.map((feature, index) => (
                  <FeatureItem key={index}>
                    <CheckIcon><img src={darkCheckCircle} /></CheckIcon>
                    <span>{feature}</span>
                  </FeatureItem>
                ))}
              </div>
            </FeaturesGrid>
          </RightSection>
        </ModalContent>
      </ModalContainer>
    </ModalOverlay>
  );
};

export default SchoolPlanModal;
